const ValidationMessage = ({ message }) => (
  <small className="fw-bold text-danger pt-1">{message}</small>
);
export default ValidationMessage;
